<template lang="pug">
v-card.ma-2
    v-card-title
        h3 {{ enquiry.FirstName }} {{ enquiry.Surname }}
    v-card-text
        a(:href="enquiry.CarLink" target="_blank") {{ enquiry.CarName }}
        p {{ enquiry.Message }}
        p Phone: {{ enquiry.Phone }}
        p Email:
            a(:href="emailLink") {{ enquiry.Email }}
    v-card-actions
        v-spacer
        v-btn.primary(@click="launchCustomerView") View Customer Trips

</template>

<script>
    export default {
        props: ["enquiry"],
        data() {
            return {
                emailLink: "mailto:" + this.enquiry.Email
            }
        },
        methods: {
            launchCustomerView() {
                window.open("https://powersell.appstack.me/#/?state=" + this.enquiry.State + "&servicecode=" + this.$dealer.serviceCode);
            }
        }
    }
</script>